import React from 'react';
import { capitalize } from 'lodash';
import { nonUserFacingTags } from '@/config/templates';
import Popover from '@mui/material/Popover';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TemplatePopover = _ref => {
  var _template$tags;

  let {
    anchorEl,
    template,
    onClose
  } = _ref;
  return template && /*#__PURE__*/_jsx(Popover, {
    id: "mouse-over-popover",
    sx: {
      pointerEvents: 'none'
    },
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    onClose: onClose,
    disableRestoreFocus: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.popover,
      children: [/*#__PURE__*/_jsx("h6", {
        className: styles.smallHeading,
        children: template.title
      }), /*#__PURE__*/_jsx("p", {
        className: styles.smallDescription,
        children: template.description
      }), (template.tags || []).length && /*#__PURE__*/_jsx("ul", {
        className: styles.tagList,
        children: (_template$tags = template.tags) === null || _template$tags === void 0 ? void 0 : _template$tags.filter(tag => !nonUserFacingTags.includes(tag)).map((tag, index) => /*#__PURE__*/_jsx("li", {
          className: styles.tagItem,
          children: capitalize(tag)
        }, `${tag}-${index}`))
      })]
    })
  });
};

export default TemplatePopover;
export const useTemplatePopover = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focusTemplate, setFocusTemplate] = React.useState(null);

  const selectPopoverTemplate = (el, tmpl) => {
    setAnchorEl(el);
    setFocusTemplate(tmpl);
  };

  const closePopoverTemlpate = () => {
    setAnchorEl(null);
    setFocusTemplate(null);
  };

  return {
    anchorEl,
    focusTemplate,
    selectPopoverTemplate,
    closePopoverTemlpate
  };
};